import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number | string;
}

const Kuzov: React.FC<IconProps> = ({
  color = "#2625e9",
  size = 40,
  className,
  style,
  ...props
}) => (
  <svg
    transform="scale(1.5)"
    viewBox="0 0 80 80"
    style={{ width: size, height: size, flexShrink: 0, ...style }}
    aria-hidden="true"
    className={className}
    {...props}
  >
<g transform="translate(0,-0)">
    <path
      d="M34.21 42.61h-3.92c-1.41 0-2.56-1.15-2.56-2.56V14.51c0-1.41 1.15-2.56 2.56-2.56h19.24c1.41 0 2.56 1.15 2.56 2.56v21c0 1.41-1.15 2.56-2.56 2.56h-5.51c-.18 0-.37.04-.53.13l-8.11 4.14c-.36.18-.76.28-1.16.28zm-3.92-29.28c-.65 0-1.17.53-1.17 1.17v25.55c0 .65.53 1.17 1.17 1.17h3.92c.18 0 .37-.04.53-.13l8.11-4.14c.36-.18.76-.28 1.16-.28h5.51c.65 0 1.17-.53 1.17-1.17V14.51c0-.65-.53-1.17-1.17-1.17H30.28zM49.53 65.56H30.46c-1.41 0-2.56-1.15-2.56-2.56v-5.89c0-.93.51-1.8 1.33-2.24l12.75-7.01c.38-.21.8-.32 1.23-.32h6.32c1.41 0 2.56 1.15 2.56 2.56V63c0 1.41-1.15 2.56-2.56 2.56zm-6.32-16.63c-.2 0-.39.05-.57.15l-12.75 7.01c-.38.21-.61.6-.61 1.03v5.89c0 .65.53 1.17 1.17 1.17h19.07c.65 0 1.17-.53 1.17-1.17v-12.9c0-.65-.53-1.17-1.17-1.17H43.2zM49.78 44.83h-5.34a1.92 1.92 0 01-1.92-1.92v-.71c0-1.06.86-1.92 1.92-1.92h5.34c1.06 0 1.92.86 1.92 1.92v.71c0 1.06-.86 1.92-1.92 1.92zm-5.34-3.15c-.29 0-.53.24-.53.53v.71c0 .29.24.53.53.53h5.34c.29 0 .53-.24.53-.53v-.71c0-.29-.24-.53-.53-.53h-5.34z"
      fill={color}
    />
    <path
      d="M52.38 71.15H27.61c-1.79 0-3.25-1.46-3.25-3.25V12.1c0-1.79 1.46-3.25 3.25-3.25h24.77c1.79 0 3.25 1.46 3.25 3.25v55.8c0 1.79-1.46 3.25-3.25 3.25zM27.62 10.24c-1.03 0-1.86.84-1.86 1.86v55.8c0 1.03.84 1.86 1.86 1.86h24.77c1.03 0 1.86-.84 1.86-1.86V12.1c0-1.03-.84-1.86-1.86-1.86H27.62z"
      fill={color}
    />
    </g>
  </svg>
);

export default Kuzov;
